import { BaseApi } from './base.api'
import { METHOD_AXIOS } from '../utils/constant'

export class AnnouncementAdminApi extends BaseApi {
	constructor() {
		super('api/admin/announcements')
	}

	async list(params = {}) {
		const q = new URLSearchParams()
		if (params.page != null) q.set('page', String(params.page))
		if (params.pageSize != null) q.set('pageSize', String(params.pageSize))
		if (params.status) q.set('status', params.status)
		if (params.platform) q.set('platform', params.platform)
		if (params.priority) q.set('priority', params.priority)
		if (params.q) q.set('q', params.q)
		const qs = q.toString()
		return this.get(qs ? `?${qs}` : '')
	}

	async getById(id) {
		return this.get(`/${id}`)
	}

	async create(data) {
		return this.requestJson('', data, METHOD_AXIOS.POST)
	}

	async update(id, data) {
		return this.requestJson(`/${id}`, data, METHOD_AXIOS.PUT)
	}

	async remove(id) {
		return this.delete(`/${id}`)
	}

	async duplicate(id) {
		return this.requestJson(`/${id}/duplicate`, {}, METHOD_AXIOS.POST)
	}
}
